export const ringStrategies: Array<string> = [
  "Roundrobin memory",
  "Fewest calls",
  "Least recent",
  "Ring all",
  "Random"
];

export const ringStrategyMap: { [key: string]: string } = {
  ["random"]: "Random",
  ["roundrobinmemory"]: "Roundrobin memory",
  ["fewestcalls"]: "Fewest calls",
  ["leastrecent"]: "Least recent",
  ["ringall"]: "Ring all"
};

export const ringStrategyMapRev: { [key: string]: string } = {
  ["Random"]: "random",
  ["Roundrobin memory"]: "roundrobinmemory",
  ["Fewest calls"]: "fewestcalls",
  ["Least recent"]: "leastrecent",
  ["Ring all"]: "ringall"
};

export const ringDurations: Array<string> = new Array(60)
  .fill(0)
  .map((_v, i) => (i + 1).toString());

export const connectionDelays: Array<string> = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "10",
  "15",
  "30",
  "60"
];

export const wrapupTimes: Array<string> = [
  "0",
  "5",
  "10",
  "20",
  "30",
  "60",
  "120",
  "180",
  "240",
  "300",
  "600",
  "900",
  "1800",
  "3600"
];

export const announceFrequencies: Array<string> = [
  "0",
  "30",
  "60",
  "90",
  "120",
  "180",
  "240",
  "300"
];

export const callerTimeouts: Array<string> = [
  "0",
  "5",
  "10",
  "20",
  "30",
  "60",
  "120",
  "180",
  "240",
  "300",
  "600",
  "900",
  "1800",
  "3600"
];

export const reportFrequencies: Array<string> = ["Daily", "Weekly", "Monthly", "Quarterly"];

export const frequencyMap: { [key: string]: string } = {
  Daily: "Daily 7",
  Weekly: "Weekly 7 1",
  Monthly: "Monthly 7 1",
  Quarterly: "Quarterly 7 1 0"
};

export enum recordingAnnouncement {
  none = "",
  basic = "basic",
  training = "training",
  monitored = "monitored"
}
